import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  GradientButtonOutline,
  GradientButton,
} from "components/GradientButton";
import api from "_api";

const ModalView = ({ open, onClose, data, fetchProductData }) => {
  const handleClose = () => {
    onClose();
  };

  const deleteData = async (id) => {
    const { isStatus } = await api.super_admin.deletePackage(id);
    if (isStatus) {
      fetchProductData();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        borderRadius: "8px",
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <Grid container spacing={3} sx={{ padding: 3 }}>
          <Grid item xs={12}>
            <Typography sx={{ mb: 3 }} variant="h4">
              การลบแพ็คเกจ
            </Typography>
            <Typography sx={{ mb: 3 }} variant="h6">
              ลบแพ็คเกจครั้งนี้จะเป็นการหายไปแบบถาวร จะไม่สามารถกู้คืนได้
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={() => handleClose()}
        >
          ยกเลิก
        </GradientButtonOutline>
        <GradientButton
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={() => {
            deleteData(data.marketplace_package_id);
            handleClose();
          }}
        >
          ตกลง
        </GradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalView;
